import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-device-icon',
  templateUrl: './device-icon.component.html',
  styleUrls: ['./device-icon.component.css']
})
export class DeviceIconComponent implements OnInit {

  @Input() deviceOperationStatus:string;

  constructor() { }

  ngOnInit() {
  }

}
